'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// 避免有请求阻塞onload时，回调执行太慢

var LOAD_TIMEOUT = 3000;

var Load = function () {
    function Load() {
        _classCallCheck(this, Load);

        this._onloads = [];
        this._timer = null;
        this._isLoaded = false;

        this._onLoad = this._onLoad.bind(this);
        window.addEventListener('load', this._onLoad);
        setTimeout(this._onLoad, LOAD_TIMEOUT);
    }

    Load.prototype.add = function add(callback) {
        if (this._isLoaded) {
            callback && callback();
            return;
        }

        this._onloads.push(callback);
    };

    Load.prototype._onLoad = function _onLoad() {
        if (this._isLoaded) {
            return;
        }

        window.clearTimeout(this._timer);
        this._onloads.forEach(function (callback) {
            callback && callback();
        });

        this._onloads = [];
        this._timer = null;
        this._isLoaded = true;
    };

    return Load;
}();

var loader = new Load();

function onload(callback) {
    loader.add(callback);
}

exports['default'] = onload;
module.exports = exports['default'];